import { checkProductionMode } from '@provider-portal/common/utils/environment';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';

import { rootEpic } from 'rdx/epic';
import { AppServices, createMiddleware } from 'rdx/middleware';
import { rootReducer } from 'rdx/reducer';
import { GlobalAppState } from 'rdx/state';

const isProductionMode = checkProductionMode();

export const createReduxStore = (appServices: AppServices) => {
  const history = createBrowserHistory();

  const { allMiddlewares, epicMiddleware } = createMiddleware(appServices);

  let middlewareEnhancers = applyMiddleware(routerMiddleware(history), ...allMiddlewares);
  if (!isProductionMode) {
    middlewareEnhancers = composeWithDevTools(middlewareEnhancers);
  }

  const store = createStore<GlobalAppState, any, any, any>(
    rootReducer(history),
    compose(middlewareEnhancers),
  );
  const persistor = persistStore(store);

  epicMiddleware.run(rootEpic);

  return { store, persistor, history };
};
